import { ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AuthGuard } from "@core/guards/auth.guard";
import { ParametrizacaoComponent } from "./pages/parametrizacao/parametrizacao.component";
import { RootComponent } from "@modules/parametrizacao/root/root.component";
import { InvasaoSetorCompletoComponent } from "./pages/invasao-setor-completo/invasao-setor-completo.component";
import { InvasaoSetorPorCidadeComponent } from "./pages/invasao-setor-por-cidade/invasao-setor-por-cidade.component";
import { HistoricoInvasaoComponent } from "./pages/historico-invasao/historico-invasao.component";

export const routing: ModuleWithProviders = RouterModule.forChild([
  {
    path: "parametrizacao",
    component: RootComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ParametrizacaoComponent,

      },
      { path: "home", component: ParametrizacaoComponent },
      { path: "invasao-setor-completo", component: InvasaoSetorCompletoComponent },
      { path: "invasao-setor-por-cidade", component: InvasaoSetorPorCidadeComponent },
      { path: "historico-invasao", component: HistoricoInvasaoComponent },
    ]
  }
]);
